import { type, type Type } from 'arktype';
import { dayKeySchema } from './day-key.model';

export const RULE_FINDING_SUBJECT_TYPE = 'timetracking.rule-finding';

export interface RuleFindingPayload {
  personId: string;
  date: string;
  ruleInstanceId: string;
  severity: 'warn';
  fingerprint: string;
  contextBookingIds: string[];
}

export const ruleFindingPayloadSchema: Type<RuleFindingPayload> = type({
  personId: 'string > 0',
  date: dayKeySchema,
  ruleInstanceId: 'string > 0',
  severity: "'warn'",
  fingerprint: 'string > 0',
  contextBookingIds: 'string[]',
});

export function ruleFindingFingerprint(verdict: {
  ruleInstanceId: string;
  severity: 'pass' | 'warn' | 'block';
  contextBookingIds: readonly string[];
}): string {
  return `${verdict.ruleInstanceId}|${verdict.severity}|${[...verdict.contextBookingIds].sort().join(',')}`;
}
